// The right-hand edge of an active-groups chart: the farm's own present, on the same scale the buckets
// beside it are stated on.
//
// Both halves matter. An axis ending at the last datapoint hides a Sensor that stopped reporting - the
// plot just gets shorter - so the edge is "now", not "last reading". And "now" comes from the FARM: these
// series state their buckets on the Directory's wall clock with no offset attached, while the browser is
// on neither that zone nor UTC, so a locally computed edge lands a whole UTC offset away from them - at
// UTC+13, thirteen hours of existing readings past the right-hand side.
//
// `directoryLocalNow` is `directory_local_now` off the live-KPI payload, parsed as UTC exactly as the
// bucket dates are. Null only before the first live-KPI read lands; the browser's UTC midnight stands in
// for that one render, because the alternative is an axis with no edge at all.
import { productivityInstant } from './productivityFormatting';

function farmNowMs(directoryLocalNow: string | null): number {
    return directoryLocalNow === null ? Date.now() : productivityInstant(directoryLocalNow);
}

// Start of the farm's current daily bucket, not the wall-clock instant: a day-bucketed series' own
// "today" point sits at exactly this timestamp, so fresh data renders flush against the edge.
export function directoryLocalDayStart(directoryLocalNow: string | null): number {
    const now = new Date(farmNowMs(directoryLocalNow));
    now.setUTCHours(0, 0, 0, 0);
    return now.getTime();
}

// Start of the farm's current hourly bucket, for the one chart (weight, hourly granularity) that
// buckets finer than a day.
export function directoryLocalHourStart(directoryLocalNow: string | null): number {
    const now = new Date(farmNowMs(directoryLocalNow));
    now.setUTCMinutes(0, 0, 0);
    return now.getTime();
}
